import { Box, Input, Text } from '@nimbus-ds/components';
import { DataList } from '@nimbus-ds/patterns';
import useTranslationConfigurations from 'domains/Configurations/useTranslationConfigurations';
import { DomainSuggestionRowSkeleton } from './components';

export function SearchNewDomainSkeleton() {
  const t = useTranslationConfigurations(
    'domains.landing.addDomainModal.searchNewDomain',
  );

  return (
    <Box display="flex" flexDirection="column" gap="4">
      <Box padding="4" paddingTop="none">
        <Input.Skeleton />
      </Box>
      <Box display="flex" flexDirection="column">
        <Box padding="4" paddingTop="none">
          <Text color="neutral-textHigh">{t('suggestions')}</Text>
        </Box>
        <DataList>
          <DomainSuggestionRowSkeleton />
        </DataList>
      </Box>
    </Box>
  );
}
